import React from 'react'
import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form'
import { TextArea, TextAreaProps } from '../../TextArea'

interface TextAreaControllerProps<T extends FieldValues> extends TextAreaProps {
  control: Control<T, any>
  name: FieldPath<T>
  shouldUnregister?: boolean
  defaultValue?: any
  meta?: any
}

export const TextAreaController = <T extends FieldValues>({
  name,
  control,
  shouldUnregister,
  defaultValue,
  ...rest
}: TextAreaControllerProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      shouldUnregister={shouldUnregister}
      defaultValue={defaultValue}
      render={({ field: { ref, ...field }, fieldState, formState }) => {
        const meta = {
          error: fieldState.error,
        }

        return <TextArea {...field} fieldRef={ref} {...rest} meta={meta} />
      }}
    />
  )
}
